/**
 * ETIQUETA DO CARD DE IMÓVEL (carrosséis) — por codsite.
 *
 * A etiqueta sobre a foto do card (`CardApartament`, modelo_card = 1) é hardcode
 * compartilhado pelos ~300 sites: "Exclusivo" para o imóvel marcado como exclusivo e,
 * na falta dele, "Lançamento" / "Mobiliado" / "Na Planta" pelo NOME da categoria.
 * Quando um cliente pede a regra dele, o pedido entra AQUI — num arquivo só, auditável,
 * com o codsite na chave —, nunca trocando o padrão de todo mundo. Mesmo molde de
 * `utils/textosSecoesPorSite.ts`.
 *
 * Fora do mapa nada muda: o card cai na regra padrão de sempre.
 *
 * cs2641 (Due Imóveis, 14/10/2026): a etiqueta "Lançamento" NÃO sai mais sozinha da
 * categoria nos carrosséis. O exclusivo segue com a etiqueta "Exclusivo" de sempre; se
 * ele TAMBÉM for lançamento, leva as duas ("Exclusivo" e "Lançamento", lado a lado).
 * Lançamento que não é exclusivo fica sem a etiqueta — a categoria continua pondo o
 * imóvel no carrossel de lançamentos, e a marcação de exclusivo decide quem a exibe.
 */
export type RegraEtiquetaCard = {
    /**
     * "Lançamento" (categoria) só aparece no imóvel marcado como exclusivo, AO LADO da
     * "Exclusivo". Sem exclusivo, a categoria "Lançamento" não gera etiqueta.
     */
    lancamentoSoNoExclusivo?: boolean;
};

const REGRAS_POR_SITE: Record<number, RegraEtiquetaCard> = {
    2641: { lancamentoSoNoExclusivo: true },
};

export function regraEtiquetaCard(siteId: unknown): RegraEtiquetaCard | null {
    return REGRAS_POR_SITE[Number(siteId)] || null;
}

/**
 * Os carrosséis da home não trazem os dois campos de que a regra depende: o PERSONALIZADO
 * (`properties_carrossel`) vem sem `exclu`, e o Top 10 / Novidades (`propertiesTop10`,
 * `imoveis_novidades`) vêm sem `categoria`. Só os sites com regra pedem o campo que
 * falta; para os demais as queries (e o payload) seguem idênticas.
 */
export function carrosselTrazExclusivoECategoria(siteId: unknown): boolean {
    return Boolean(regraEtiquetaCard(siteId)?.lancamentoSoNoExclusivo);
}
